import { useState, useEffect, useCallback } from "react";
import { get } from "lodash-es";
import { getSystemActivityStatistics } from "../repositories/system-activity-statistics-repository";
import type { SystemActivityStatistic } from "../models/system-activity-statistic";

export const useSearchSystemActivityStatistics = () => {
	const [statistics, setStatistics] = useState<SystemActivityStatistic[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);
	const [searchText, setSearchText] = useState<string>("");

	const searchSystemActivityStatistics = useCallback(async () => {
		setLoading(true);
		setError(null);

		const res = await getSystemActivityStatistics();

		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setStatistics(rowsSource);
		} else {
			setError(res.message || "Failed to fetch system activity statistics");
		}

		setLoading(false);
	}, []);

	useEffect(() => {
		searchSystemActivityStatistics();
	}, [searchSystemActivityStatistics]);

	const filteredStatistics = statistics.filter((stat) =>
		stat.Metric.toLowerCase().includes(searchText.toLowerCase()),
	);

	const updateSearchText = useCallback((text: string) => {
		setSearchText(text);
	}, []);

	const resetSearch = useCallback(() => {
		setSearchText("");
	}, []);

	const refetchStatistics = useCallback(() => {
		searchSystemActivityStatistics();
	}, [searchSystemActivityStatistics]);

	return {
		statistics: filteredStatistics,
		loading,
		error,
		searchText,
		searchSystemActivityStatistics,
		refetchStatistics,
		updateSearchText,
		resetSearch,
	};
};
